// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCheckCardBinFile, useAddCheckedCardBinFile } from "../../../hooks";
import { Box, Card, CardContent, Divider, FormControl, Grid, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import { Button, StatusBarCardBinExcelUploadList, Loading } from "../../atoms";
import {
  GridColDef,
  GridActionsCellItem,
  GridRenderCellParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React, { useRef, useMemo, useState } from "react";
import GetAppIcon from '@mui/icons-material/GetApp';
import ErrorIcon from '@mui/icons-material/Error';
import { Table } from "../../molecules";
import { createStatusOperator } from "../../molecules/StatusFilterComponents";

function RenderOperation(props: GridRenderCellParams<any, string>) {
  const { value } = props;
  return <>{value && <StatusBarCardBinExcelUploadList operation={value} isValid={props.row.isValid} />}</>;
}

export const CardBinAddBulkUploadForm = () => {
  const navigate = useNavigate();
  // const {showCreate} = useAuthorization();
  const theme = useTheme();
  // const commissionProfile = useLocation()
  // .state as unknown as ICommissionProfileForPage;
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  // const { control, reset, handleSubmit } =
  //   useForm<BankAddProfileFormSchemaFormValuesType>({
  //     resolver: zodResolver(bankAddProfileFormSchema),
  //   });
  const setSnackbar = useSetSnackBar();

  // const { mutate: commissionFilesUpload,isLoading } = useAddCommissionParameterFiles();



  const FileUpdload = ({ }) => {

    const fileURL = "/files/Toplu-Kart-Bin-Yukleme.xlsx";

    const [paginationModel, setPaginationModel] = useState({
      page: 0,
      pageSize: 25
    });
    const [queryOptions, setQueryOptions] = React.useState({});
    const [tableData, setTableData] = useState([]);
    const [responseData, setResponseData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [hasCheckedFile, setHasCheckedFile] = useState(false);
    const [uploadCompleted, setUploadCompleted] = useState(false);
    const [uploadSuccessful, setUploadSuccessful] = useState(false)
    const { mutate: checkCardBinFile } = useCheckCardBinFile();
    const { mutate: uploadCheckCardBinFile } = useAddCheckedCardBinFile();

    const checkFileExtension = (file) => {
      const acceptedExtension = 'xlsx';
      const currentExtension = file.name.split('.').pop();
      return currentExtension === acceptedExtension;
    };

    const fileInput = useRef();

    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        if (checkFileExtension(selectedFile)) {
          setFile(selectedFile);
          setHasCheckedFile(false); // Yeni bir dosya seçildiğinde kontrolün tekrar yapılması için bu değeri sıfırlıyoruz.
          setUploadCompleted(false);
        } else {
          setFile(null);
          fileInput.current.value = '';
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "Lütfen .xlsx formatında dosya yükleyiniz",
          });
        }
      }

    };

    const handleCheckFile = async () => {
      if (!file) return;

      setTableData(undefined);
      setLoading(true);

      const formData = new FormData();
      formData.append('excelFile', file);

      checkCardBinFile(formData, {
        onSuccess: (data) => {
          setLoading(false);
          if (data.isSuccess) {
            setHasCheckedFile(true);
            // setResponseData(data);
            setTableData(data);
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: "Dosya kontrolü başarılı! Yüklemeye devam edebilirsiniz.",
            });
          } else {
            setHasCheckedFile(false);
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message || "Dosya kontrolünde hata oluştu",
            });
          }
        },
        onError: (error) => {
          setLoading(false);
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    };

    const handleSubmit = async () => {

      if (!file || !hasCheckedFile) return;

      setLoading(true);

      const formData = new FormData();
      formData.append('excelFile', file);

      uploadCheckCardBinFile(formData, {
        onSuccess: (data) => {
          setLoading(false);
          setUploadCompleted(true);
          setHasCheckedFile(false);
          setResponseData(data);
          setTableData(undefined);
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: "Dosya Yükleme İşlemi Başarıyla Gerçekleşti",
            });
            setUploadSuccessful(true);
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message || "Dosya yüklenirken bir hata oluştu",
            });
          }
        },
        onError: (error) => {
          setLoading(false);
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }

    const columns: GridColDef<IUser, any, any>[] = useMemo(() => {
      return [
        {
          renderCell: RenderOperation,
          field: "operation",
          headerName: "Durum",
          width: 150,
          filterOperators: [createStatusOperator([
            {
              label: 'EKLENECEK', value: 'ADD'
            },
            {
              label: 'GÜNCELLENECEK', value: 'UPDATE'
            },
            {
              label: 'SİLİNECEK', value: 'DELETE'
            },
            {
              label: 'GEÇERSİZ', value: 'INVALID'
            }
          ])]
        },
        { field: "errorMessage", headerName: "Hata Mesajı", width: 200 },
        { field: "bin", headerName: "Bin", width: 80 },
        { field: "bankCode", headerName: "Banka Kodu", width: 120 },
        { field: "serviceProviderId", headerName: "Service Provider Id", width: 120 },
        { field: "cardRangeStart", headerName: "Kart Başlangıç", width: 150 },
        { field: "cardRangeEnd", headerName: "Kart Bitiş", width: 150 },
        { field: "cardNumberLen", headerName: "Kart No. Uzunluğu", width: 120 },
        { field: "checkDigitAlgorithm", headerName: "Check Digit Algorithm", width: 120 },
        { field: "effectiveDateAuthorisation", headerName: "Efektif Yetkilendirme Tarihi", width: 120 },
        { field: "effectiveDateSettlement", headerName: "Efektif Kabul Tarihi", width: 120 },
        { field: "domesticInternational", headerName: "Domestic International", width: 120 },
        { field: "paymentSystem", headerName: "Payment System", width: 120 },
        { field: "cardType", headerName: "Card Type", width: 80 },
        { field: "productType", headerName: "Ürün Tipi", width: 120 },
        { field: "cardSubType", headerName: "Kart alt tipi", width: 120 },
        { field: "cardAttributes", headerName: "Card Attributes", width: 200 },
        { field: "preAuthorisation", headerName: "Pre-Authorisation", width: 200 },
        { field: "onlinePinRequired", headerName: "Online Pin Required", width: 200 },
        { field: "signature", headerName: "signature", width: 200 },
        { field: "authenticationType", headerName: "Authentication Type", width: 120 },
        { field: "brandName", headerName: "Brand Name", width: 120 },
      ];
    });

    const handleChangePagination = (model: GridPaginationModel) => {
      setPaginationModel(model);
    }

    const previousQueryParams = React.useRef({});
  
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(null, args);
        }, delay);
      };
    };
    const getQueryParams = (filters) => {
      const queryParams = {};

      for (let key in filters) {
        if (filters[key]?.toString()?.length >= 1) {
          queryParams[key] = filters[key];
        }
      }

      return queryParams;
    };
    const handleFilterChange = debounce((filters) => {
      if (filters.clearFilter) {
        localStorage.removeItem("cardBinFilter");
        return setQueryOptions({});
      }
      const queryParams = getQueryParams(filters);
      const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
      const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

      const previousKeysLength = Object.keys(previousQueryParams.current).length;
      const currentKeysLength = Object.keys(queryParams).length;

      // Eğer queryParams bir önceki ile aynıysa işlem yapma
      if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
        return;
      }

      if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
        setQueryOptions(queryParams);
        localStorage.setItem("cardBinFilter", JSON.stringify(queryParams));
      }

      // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
      previousQueryParams.current = queryParams;

    }, 500);

    return (
      <>
        {loading && <Loading />}
        <Box sx={{ width: '100%', marginBottom: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={7}>
              <TextField
                variant="outlined"
                fullWidth
                type="file"
                onChange={handleFileChange}
                InputLabelProps={{
                  shrink: true,
                }}
                inputRef={fileInput}
                sx={{ height: '55px' }}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                text={!hasCheckedFile ? "Yükle" : !hasCheckedFile ? "Yükle" : "Yüklemeyi Tamamla"}
                variant="contained"
                color="primary"
                disabled={!file || loading || (uploadCompleted && !hasCheckedFile)}
                onClick={!hasCheckedFile ? handleCheckFile : handleSubmit}
                fullWidth
                sx={{ height: '55px' }}
              >
                {uploadCompleted && !hasCheckedFile ? "Yükle" : !hasCheckedFile ? "Yükle" : "Yüklemeyi Tamamla"}
              </Button>


            </Grid>
            <Grid item xs={3}>
              <Button variant="contained" text="TOPLU BİN YÜKLEME DOSYASINI İNDİR" color="primary" startIcon={<GetAppIcon />} href={fileURL} download sx={{ height: '55px', width: '100%' }}>
                Dosyayı İndir
              </Button>
            </Grid>
          </Grid>
        </Box>

        {uploadCompleted && (
          uploadSuccessful ? (
            <>
              {/* <Card sx={{ minWidth: '100%', minHeight: 100, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
                <CardContent>
                  
                </CardContent>
              </Card> */}
              <Card sx={{ minWidth: 275, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
                <CardContent>
                  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <CheckCircleIcon color="success" fontSize="large" />
                    <Typography variant="h5" style={{ color: theme.palette.success.main, fontWeight: 'bold' }}>
                      Dosya Başarıyla Yüklendi
                    </Typography>
                  </Box>
                  <Divider sx={{ margin: 5 }} />
                  <Box sx={{ marginLeft: 2, marginRight: 2 }}>
                    <Typography variant="h3" component="div" color="primary" gutterBottom>
                      İşlem Bilgileri
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      Toplam Kayıt: {responseData.data?.totalRecord}
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      Eklenen Kayıt: {responseData?.data?.totalInsertRecords}
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      Güncellenen Kayıt: {responseData?.data?.totalUpdatedRecords}
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      Silinen Kayıt: {responseData?.data?.totalDeletedRecords}
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      Geçersiz Kayıt: {responseData?.data?.totalInvalidRecords}
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      Hata Mesajları:
                    </Typography>
                    {responseData && responseData.data.errorMessages ? (
                      <div>
                        <Box display="flex" alignItems="center" gap={1}>
                          <ErrorIcon color="error" fontSize="large" />
                          <Typography variant="body1" style={{ color: theme.palette.error.main, fontWeight: 'bold' }}>
                            Toplam {responseData.data.errorMessages.length} hata bulundu:
                          </Typography>
                        </Box>
                        {responseData.data.errorMessages.map((error, index) => (
                          <Typography key={index} ml={6} variant="body2" color="error" style={{ fontSize: 'medium' }}>
                            {index + 1}. {error}
                          </Typography>
                        ))}
                      </div>
                    ) : (
                      <Box display="flex" alignItems="center" gap={1}>
                        <CheckCircleIcon color="success" fontSize="large" />
                        <Typography variant="body1" style={{ color: theme.palette.success.main, fontWeight: 'bold' }}>
                          Herhangi Bir Hata Yok
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </>
          ) : (
            <Card sx={{ minWidth: '100%', minHeight: 100, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <ErrorIcon color="error" fontSize="large" />
                  <Typography variant="h5" style={{ color: theme.palette.error.main, fontWeight: 'bold' }}>
                    Dosya Yüklenirken Bir Hata Oluştu
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          )
        )}

        {tableData?.data?.length > 0 && (
          <Table
            filterKey="cardBinFilter"
            columnVisibilityConfigKey="cardBinColumnVisibilityKey"
            hasActiveFilters={hasActiveFilters}
            handleFilterChange={handleFilterChange}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="client"
            filterMode="client"
            rowCount={tableData?.data?.length || 0}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            isRowSelectable={() => false}
            // disableColumnMenu  
            rows={tableData?.data || []}
            columns={columns}
            getRowClassName={(params) => {
              if (params.row.operation === "UPDATE") return "card-bin-update-row";
              if (params.row.operation === "DELETE") return "card-bin-delete-row";
              if (params.row.operation === "INVALID") return 'card-bin-invalid-row';
              return "card-bin-add-row";
            }}
            exportFileName="Kart Bin Listesi"
            onSave={() => { }}
          />
        )}


      </>
    );
  };

  const DownloadButton = () => {
    const fileURL = "/files/Sanal-Pos-Toplu-Komisyon-Yükleme-Güncelleme.xlsx";


    return (
      <Button variant="contained" text="TOPLU BİN YÜKLEME DOSYASINI İNDİR" color="primary" startIcon={<GetAppIcon />} href={fileURL} download sx={{ height: '55px' }}>
        Dosyayı İndir
      </Button>
    );
  };


  const handleBack = () => navigate("/commission-management/commission-codedefinition");

  return (
    <>

      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <Stack spacing={4}>
            <Stack spacing={3}>
              <Stack
                spacing={3}
                width={isDesktop ? '100%' : "auto"}
                direction="column"
              >
                <FormControl sx={{ flex: 1 }}>
                  <FileUpdload />
                </FormControl>

              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
